import React, { useEffect, useState } from 'react';
import './OnPremSiteToSiteVPNRequestsDetail.css';
import RequestFormWrapper from '../common/wrappers/RequestFormWrapper';
import { Alert, Button, Grid, TextLink, TextPassage, Radio } from 'react-unity';
import { AlertBanner } from '../../models/interfaces/AlertBanner';
import ReactButton from '../common/ReactButton';
import ConfirmModal from '../common/modals/ConfirmModal';
import AlertModal from '../common/modals/AlertModal';
import SelectField from '../common/form-controls/SelectField';
import { useNavigate, useParams } from 'react-router-dom';
import OnPremVPNScopeInput from './components/OnPremVPNScopeInput';
import { useAbstractSiteToSiteVPNForm } from './components/AbstractSiteToSiteVPNForm';
import TextInputField from '../common/form-controls/TextInputField';
import SubmitOnPremSiteToSiteVPNRequest from '../../models/viewModels/OnPremSiteToSiteVPNRequests/SubmitOnPremSiteToSiteVPNRequest';
import { Validation } from '../../utils/Validation';
import ExxonMobilSiteToSiteVPNConfigurationForm from './components/siteToSiteVPNConfiguration/ExxonMobilSiteToSiteVPNConfigurationForm';
import ExternalMobilSiteToSiteVPNConfigurationForm from './components/siteToSiteVPNConfiguration/ExternalMobilSiteToSiteVPNConfigurationForm';
import StandardSiteToSiteVPNConfigurationForm from './components/siteToSiteVPNConfiguration/StandardSiteToSiteVPNConfigurationForm';
import WorkflowDetailWrapper from '../common/wrappers/OnPremWorkflowDetailWrapper';
import PortOpeningRequestSiteToSiteOnPrem from '../../models/entities/PortOpeningRequestSiteToSiteOnPrem';
import OnPremObjectRequestService from '../../services/OnPremPORequestObjectService';
import OnPremPORSiteToSiteVPNService from '../../services/OnPremPORSiteToSiteVPNService';
import { TreeNavigation } from 'react-unity';
import { WorkflowState } from '../../models/enums/WorkflowState';
import UpdateOnPremS2SRequest from '../../models/viewModels/OnPremSiteToSiteVPNRequests/UpdateOnPremS2SRequest';
import ProgressBarBig from './components/ProgressBarBig';

type Mode = 'create' | 'detail' | 'edit';

const OnPremSiteToSiteVPNRequestsDetail = () => {
    const {
        state,
        setState,
        formModel,
        getStateFormHandlers,
        handleSubmissionAlertClose,
        handleEndModal,
        handleStateFormChange,
        getLinkTree,
        isValid,
        endAndRedirect,
        handleStandardConfigData,
        handleApproverDelegateOptions
    } = useAbstractSiteToSiteVPNForm();

    const stateFormHandler = () => getStateFormHandlers();
    const [loading, setLoading] = useState<boolean>(true);
    const [siteToSiteVPNRequest, setsiteToSiteVPNRequest] = useState<PortOpeningRequestSiteToSiteOnPrem>();
    const [operationInProgress, setOperationInProgress] = useState<boolean>(false);
    const [loadingTracker, setLoadingTracker] = useState<boolean>(false);
    const [submissionAlert, setSubmissionAlert] = useState<AlertBanner>({ visible: false });
    const [cancelModalVisible, setCancelModalVisible] = useState<boolean>(false);
    const [decisionModalVisible, setDecisionModalVisible] = useState<{
        approve?: boolean;
        reject?: boolean;
        review?: boolean;
        cancel?: boolean;
        complete?: boolean;
    }>({});
    const [modalComment, setModalComment] = useState<string>('');
    const navigate = useNavigate();
    const params = useParams<string>();

    const [editMode, setEditMode] = useState<boolean>(false);
    const [mode, setMode] = useState<Mode>('detail');

    const [optionSelected, setOptionSelected] = useState<number | null>(null);
    const [checkboxOptions, setCheckBoxOptions] = useState([
        { id: 1, label: "Option 1 - IKEv2 with AES-GCM (256-bit)/SHA-512/DH31", value: "Option 1 - IKEv2 with AES-GCM (256-bit)/SHA-512/DH31", method: 1, checked: false },
        { id: 2, label: "Option 2 - IKEv2 with AES-GCM (256-bit)/SHA-512/DH19", value: "Option 2 - IKEv2 with AES-GCM (256-bit)/SHA-512/DH19", method: 2, checked: false },
        { id: 3, label: "Option 3 - IKEv2 with AES-256/SHA-256/DH19", value: "Option 3 - IKEv2 with AES-256/SHA-256/DH19", method: 3, checked: false },
        { id: 4, label: "Option 4 - Exception (with Policy Approval)", value: "Option 4 - Exception (with Policy Approval)", method: 4, checked: false },
    ]);

    const isDisabled = operationInProgress || mode === 'detail';
    const isEdit = editMode && !operationInProgress;

    const handleCancel = () => {
        setCancelModalVisible(false);
        setOperationInProgress(false);
        navigate('/onPremSiteToSiteVPN');
    };

    const handleCheck = (option) => {
        if (option.checked) return;
        setCheckBoxOptions(
            checkboxOptions.map((o) =>
                o.id == option.id ? { ...o, checked: !o.checked } : { ...o, checked: false }
            )
        );
        checkboxOptions.map((o) => {
            o.id == option.id && setOptionSelected(o.method)
        })

        setState(prevState => ({
            ...prevState,
            stateForm: {
                ...prevState.stateForm,
                selectedOption: option.method
            }
        }));
    };

    const openDecisionModal = (type: 'approve' | 'reject' | 'review' | 'cancel' | 'complete', status?: 'success' | 'failure') => {
        setDecisionModalVisible({ [type]: true });
        if (type === 'complete' && status) {
            setCompleteStatus(status);
        }
    };

    const closeDecisionModal = () => {
        setDecisionModalVisible({});
        setModalComment('');
    };

    const vpnService = new OnPremPORSiteToSiteVPNService();

    const setEmbedAlertSuccess = (message: string) => {
        setSubmissionAlert({
            variant: 'success',
            text: message,
            visible: true,
        });
        setTimeout(handleSubmissionAlertClose, 5000);
    };

    const setSubmissionAlertError = (message: string) => {
        setSubmissionAlert({
            variant: 'error',
            text: message,
            visible: true,
        });
    };

    const setSubmissionAlertInProgress = (message: string) => {
        setSubmissionAlert({
            variant: 'default',
            text: message,
            visible: true,
        });
    };

    const handleOperationConfirmed = async ({
        operation,
        inProgressMessage,
        successMessage,
    }) => {
        setSubmissionAlertInProgress(inProgressMessage);
        closeDecisionModal();
        try {
            await operation();
            await loadRequest(params.porId);
            setEmbedAlertSuccess(successMessage);
        } catch (err) {
            setSubmissionAlertError(err?.body?.message ?? 'An error occurred when processing your request. Please, try again later.');
        } finally {
            setOperationInProgress(false);
            setModalComment('');
        }
    };

    const handleApprove = async () => {
        await handleOperationConfirmed({
            operation: async () => {
                await vpnService.approve(siteToSiteVPNRequest?.id, { rejectionReason: modalComment });
            },
            inProgressMessage: 'Approving...',
            successMessage: 'Request approved successfully.'
        });
    };
    const handleReject = async () => {
        await handleOperationConfirmed({
            operation: async () => {
                await vpnService.reject(siteToSiteVPNRequest?.id, { rejectionReason: modalComment });
            },
            inProgressMessage: 'Rejecting...',
            successMessage: 'Request rejected successfully.'
        });
    };

    const handleReview = async () => {
        await handleOperationConfirmed({
            operation: async () => {
                await vpnService.doReviewal({ reviewReason: modalComment }, siteToSiteVPNRequest?.id);
            },
            inProgressMessage: 'Sending to review...',
            successMessage: 'Request sent to review successfully.'
        });
    };

    const [completeStatus, setCompleteStatus] = useState<'success' | 'failure'>('success');

    const handleComplete = async (status) => {
        const isSuccess = status === 'success';
        await handleOperationConfirmed({
            operation: async () => {
                await vpnService.doComplete(
                    {
                        Reason: modalComment,
                        IsApproved: true,
                        Successful: isSuccess,
                        ChangeTicketId: siteToSiteVPNRequest?.changeTicketId ?? null
                    },
                    siteToSiteVPNRequest?.id
                );
            },
            inProgressMessage: 'Completing...',
            successMessage: 'Request completed successfully.'
        });
    };

    const handleCancellation = async () => {
        await handleOperationConfirmed({
            operation: async () => {
                await vpnService.cancel(siteToSiteVPNRequest.id, { cancellationReason: modalComment });
            },
            inProgressMessage: 'Cancelling...',
            successMessage: 'Request cancelled successfully.'
        });
    };

    const decisionModalConfirmationField = () => ({
        label: 'Please, provide the reason.',
        value: modalComment,
        validation: { required: true },
        onChange: (ev) => setModalComment(ev.target.value)
    });

    const loadRequest = async (id) => {
        try {
            const request = await vpnService.getById(id);
            const mappedRequest = new PortOpeningRequestSiteToSiteOnPrem(request);
            mappedRequest.workflowInstance.currentWorkflowInstanceState.onPremWorkflowState == WorkflowState.Review ? await handleApproverDelegateOptions(mappedRequest.trackerID) : loadApproverOptions(request)

            setsiteToSiteVPNRequest(mappedRequest);
            setState(prev => ({
                ...prev,
                stateForm: {
                    ...prev.stateForm,
                    ...mappedRequest,
                    approver: request.approver.id,
                    type: request.type?.toString() ?? null,
                }
            }));
            setOptionSelected(request.selectedOption);
            setCheckBoxOptions(prev =>
                prev.map(opt => ({
                    ...opt,
                    checked: opt.method === request.selectedOption
                }))
            );

            formModel.fields.trackerID.validation = new Validation({
                required: () => true,
                rules: [
                    {
                        assert: () => /^[0-9]*$/.test(request.trackerID?.toString() ?? ''),
                        message: 'Only numbers are valid values'
                    },
                    {
                        assert: () => request.trackerID >= 10000,
                        message: 'Tracker ID must be grater than 10000'
                    }
                ]
            });

            setLoading(false);
            return request;
        }
        catch (error) {
            const HTTP_FORBIDDEN_ERROR_CODE = 403;
            if (error.status === HTTP_FORBIDDEN_ERROR_CODE) {
                handleEndModal('You are not allowed to see this request.', 'error', 5000, '/onPremSiteToSiteVPN');
            } else {
                handleEndModal('The request could not be retrieved.', 'error', 10000, '/onPremSiteToSiteVPN');
            }
            setLoading(false);
        }
    };

    useEffect(() => {
        setLoading(true);
        const id = params.porId;
        const fetchData = async () => {
            try {
                await handleStandardConfigData();
                await loadRequest(id);
            }
            catch (error) {
                console.log(error);
            }
        };
        fetchData();
    }, [params.porId]);

    const loadApproverOptions = (por) => {
        const approverOptions = [];
        approverOptions.push({ value: por.approver.id, text: por.approver.displayName })
        setState(prevState => ({
            ...prevState,
            approverOptions: approverOptions
        }));
    }

    const handleSaveReview = async () => {
        setOperationInProgress(true);
        setSubmissionAlertInProgress('Updating request...');
        try {
            const model = formModel.create(UpdateOnPremS2SRequest);
            model.option = optionSelected;
            if (model.standardConfiguration) {
                model.standardConfiguration.option = optionSelected;
            }
            await vpnService.update(siteToSiteVPNRequest?.id, model);
            setEditMode(false);
            setEmbedAlertSuccess('Your request was updated successfully.');
            await loadRequest(siteToSiteVPNRequest?.id);
        } catch (err) {
            setSubmissionAlertError(
                err?.body?.message ?? 'An error occurred when updating your request. Please, try again later.'
            );
        } finally {
            setOperationInProgress(false);
        }
    };

    const editActions = (
        <div style={{ display: 'flex', gap: '1rem', marginBottom: '1rem' }}>
            <Button
                variant="secondary"
                onClick={() => {
                    setEditMode(false);
                    loadRequest(siteToSiteVPNRequest?.id);
                }}
                disabled={operationInProgress}
            >
                Cancel
            </Button>
            <Button
                variant="primary"
                onClick={handleSaveReview}
                disabled={operationInProgress}
            >
                Finish Review
            </Button>
        </div>
    );

    const actions = () => {
        if (!siteToSiteVPNRequest) return null;
        if (editMode) {
            return editActions;
        }
        const currentState = siteToSiteVPNRequest.workflowInstance.currentWorkflowInstanceState.onPremWorkflowState.value;
        const isAwaitingImplementation = currentState === WorkflowState.AwaitingImplementation.value;

        return (
            <TreeNavigation className="em-u-clickable">
                {siteToSiteVPNRequest.isEditable() && (
                    <>
                        <TreeNavigation.Item
                            label="Edit"
                            className="em-c-btn em-c-btn--secondary em-c-btn--small"
                            onClick={() => setEditMode(true)}
                        />
                        <br /><br />
                    </>
                )}
                {(siteToSiteVPNRequest.canHaveApproval() || siteToSiteVPNRequest.canHaveCompletion()) && (
                    <>
                        <TreeNavigation.Item
                            label={isAwaitingImplementation ? "Success" : "Approve"}
                            className="em-c-btn em-c-btn--secondary em-c-btn--small"
                            onClick={() => {
                                if (isAwaitingImplementation) {
                                    openDecisionModal('complete', 'success');
                                } else {
                                    openDecisionModal('approve');
                                }
                            }}
                        />
                        <br /><br />
                    </>
                )}
                {(siteToSiteVPNRequest.canHaveRejection() || siteToSiteVPNRequest.canHaveCompletion()) && (
                    <>
                        <TreeNavigation.Item
                            label={isAwaitingImplementation ? "Failure" : "Reject"}
                            className="em-c-btn em-c-btn--secondary em-c-btn--small"
                            onClick={() => {
                                if (isAwaitingImplementation) {
                                    openDecisionModal('complete', 'failure');
                                } else {
                                    openDecisionModal('reject');
                                }
                            }}
                        />
                        <br /><br />
                    </>
                )}
                {siteToSiteVPNRequest.canHaveReview() && (
                    <>
                        <TreeNavigation.Item
                            label="Send to Review"
                            className="em-c-btn em-c-btn--secondary em-c-btn--small"
                            onClick={() => openDecisionModal('review')}
                        />
                        <br /><br />
                    </>
                )}
                {siteToSiteVPNRequest.canHaveCancellation() && (
                    <>
                        <TreeNavigation.Item
                            label="Cancel"
                            className="em-c-btn em-c-btn--secondary em-c-btn--small"
                            onClick={() => openDecisionModal('cancel')}
                        />
                        <br /><br />
                    </>
                )}
            </TreeNavigation>
        );
    };

    return (
        ((!loading &&
            siteToSiteVPNRequest != null &&
            siteToSiteVPNRequest.isEditable() &&
            siteToSiteVPNRequest?.workflowInstance.currentWorkflowInstanceState.onPremWorkflowState.value === WorkflowState.Draft.value
        ))
            ?
            <></>
            :
            <>
                <WorkflowDetailWrapper
                    title={`Port Opening Site to Site VPN Request #${siteToSiteVPNRequest?.id}`}
                    workflowInstance={siteToSiteVPNRequest?.workflowInstance}
                    loading={loading}
                    linkTree={getLinkTree()}
                    actions={actions()}
                >
                    <p>
                        For more information about Site to Site VPNs{' '}
                        <TextLink className='em-u-margin-right-none' external target="_blank" href='https://goto/POR'>
                            Click here
                        </TextLink>
                    </p>
                    {submissionAlert.visible &&
                        <Alert
                            variant={submissionAlert.variant}
                            onClose={handleSubmissionAlertClose}
                        >
                            {submissionAlert.text}
                        </Alert>
                    }
                    {siteToSiteVPNRequest?.changeTicketId != null && <Grid variant="3-up">
                        <Grid.Item>
                            <TextInputField
                                label="Change Request Ticket"
                                {...stateFormHandler().changeTicketId}
                                disabled={state.operationInProgress || !siteToSiteVPNRequest?.changeTicketId}
                                note={editMode ? "Please, add ServiceNow ticket" : ''}
                            />
                        </Grid.Item>
                    </Grid>}
                    <Grid variant="2-up">
                        <Grid.Item>
                            <OnPremVPNScopeInput
                                direction={stateFormHandler().type}
                            />
                        </Grid.Item>
                        <Grid.Item>
                            <TextInputField
                                label="Third Party Company Name"
                                {...stateFormHandler().companyName}
                                disabled={!isEdit}
                            />
                        </Grid.Item>
                    </Grid>
                    <Grid variant="2-up">
                        <Grid.Item>
                            <TextInputField
                                label="Tracker ID"
                                {...stateFormHandler().trackerID}
                                disabled={!isEdit}
                            />
                        </Grid.Item>
                        <Grid.Item>
                            <SelectField
                                label="Owner Approver"
                                className="full-width"
                                aria-placeholder={stateFormHandler().approver.value}
                                {...stateFormHandler().approver}
                                disabled={!isEdit}
                            />
                        </Grid.Item>
                    </Grid>
                    <Grid>
                        <Grid.Item>
                            <ProgressBarBig
                                workflowState={siteToSiteVPNRequest?.workflowInstance.currentWorkflowInstanceState.onPremWorkflowState}
                                por={siteToSiteVPNRequest}
                            />
                        </Grid.Item>
                    </Grid>
                    <Grid variant="halves">
                        <Grid.Item>
                            <TextPassage>
                                <h3>Section 1: Tunnel End Point Information</h3>
                            </TextPassage>
                        </Grid.Item>
                    </Grid>
                    <Grid variant="2-up">
                        <ExxonMobilSiteToSiteVPNConfigurationForm
                            mode={mode}
                            {...stateFormHandler().exxonConfiguration}
                            operationInProgress={operationInProgress}
                            readonly={isDisabled}
                            isEdit={isEdit}
                        />
                        <ExternalMobilSiteToSiteVPNConfigurationForm
                            mode={mode}
                            {...stateFormHandler().externalConfiguration}
                            operationInProgress={operationInProgress}
                            readonly={isDisabled}
                            isEdit={isEdit}
                        />
                    </Grid>
                    <TextPassage>
                        <h5>Section 2: ExxonMobil S2S VPN Standard Configuration</h5>
                    </TextPassage>
                    <Radio.Group label="Default Wired Up List">
                        {checkboxOptions.map(option => (
                            <Radio
                                key={option.id}
                                value={option.id}
                                label={option.label}
                                checked={option.checked}
                                disabled={!isEdit}
                                onClick={() => {
                                    if (isEdit) handleCheck(option);
                                }}
                            />
                        ))}
                    </Radio.Group>
                    <Grid variant='halves'>
                        {optionSelected != null && 
                            <StandardSiteToSiteVPNConfigurationForm
                                {...stateFormHandler().standardConfiguration}
                                mode={isEdit ? 'create' : mode}
                                optionSelected={optionSelected}
                                standardConfigurationData={state.standardConfigurationData}
                                operationInProgress={operationInProgress}
                                disabled={!isEdit}
                            />}
                    </Grid>
                    <TextPassage>
                        <h5>Section 3: Encryption Domain Information</h5>
                    </TextPassage>
                    <Grid variant="halves">
                        <Grid.Item>
                            <TextInputField
                                label="ExxonMobil Encryption Domain"
                                {...stateFormHandler().exxonEncrypDomain}
                                disabled={!isEdit}
                            />
                        </Grid.Item>
                        <Grid.Item>
                            <TextInputField
                                label="External Company Encryption Domain"
                                {...stateFormHandler().externalEncrypDomain}
                                disabled={!isEdit}
                            />
                        </Grid.Item>
                        <Grid.Item>
                            <TextInputField
                                label="Connected Device Count"
                                {...stateFormHandler().conDeviceCount}
                                disabled={!isEdit}
                            />
                        </Grid.Item>
                    </Grid>
                </WorkflowDetailWrapper>
                <ConfirmModal
                    visible={cancelModalVisible}
                    title='Cancel Request?'
                    question="Are you sure you want to cancel this request? This action cannot be undone."
                    confirmButton={{
                        label: 'Yes',
                        props: {
                            variant: 'primary',
                            color: 'negative'
                        }
                    }}
                    cancelButton={{
                        label: 'No',
                    }}
                    onConfirm={handleCancel}
                    onCancel={() => {
                        setCancelModalVisible(false);
                        setOperationInProgress(false);
                    }}
                />
                <ConfirmModal
                    visible={decisionModalVisible.approve}
                    title={`Approve VPN Request #${siteToSiteVPNRequest?.id}`}
                    question="Are you sure you want to approve this request?"
                    confirmationField={decisionModalConfirmationField()}
                    onConfirm={handleApprove}
                    onCancel={closeDecisionModal}
                />
                <ConfirmModal
                    visible={decisionModalVisible.reject}
                    title={`Reject VPN Request #${siteToSiteVPNRequest?.id}`}
                    question="Are you sure you want to reject this request?"
                    confirmationField={decisionModalConfirmationField()}
                    onConfirm={handleReject}
                    onCancel={closeDecisionModal}
                />
                <ConfirmModal
                    visible={decisionModalVisible.review}
                    title={`Send VPN Request #${siteToSiteVPNRequest?.id} to Review`}
                    question="Are you sure you want to send this request to review?"
                    confirmationField={decisionModalConfirmationField()}
                    onConfirm={handleReview}
                    onCancel={closeDecisionModal}
                />
                <ConfirmModal
                    visible={decisionModalVisible.complete}
                    title={`Complete VPN Request #${siteToSiteVPNRequest?.id}`}
                    question="Are you sure you want to mark this request as complete?"
                    confirmationField={decisionModalConfirmationField()}
                    onConfirm={() => handleComplete(completeStatus)}
                    onCancel={closeDecisionModal}
                />
                <ConfirmModal
                    visible={decisionModalVisible.cancel}
                    title={`Cancel VPN Request #${siteToSiteVPNRequest?.id}`}
                    question="Are you sure you want to cancel this request? This action cannot be undone."
                    confirmationField={decisionModalConfirmationField()}
                    confirmButton={{
                        label: 'Cancel Request',
                        props: {
                            variant: 'primary',
                            color: 'negative'
                        }
                    }}
                    onConfirm={handleCancellation}
                    onCancel={closeDecisionModal}
                />
                <AlertModal
                    {...state.endModal}
                    willTimeout={false}
                    onClose={endAndRedirect}
                />
            </>
    );
};

export default OnPremSiteToSiteVPNRequestsDetail;